import { Transition } from "../../../core/flows/Transition";
import { TopBarContext } from "../../TopBar/Context/TopBarContext";
import { MyAccountContext } from "../Context/MyAccountContext";

export class MyAccountTransition extends Transition {
    constructor(entryStep: string, exitSteps: string[]) {
        super(entryStep, exitSteps);
    }

    onExecute(): string[] {
        const context = this.getCtx<MyAccountContext>("myAccountContext", this.entryStep);

        const topBarContext = new TopBarContext()
        
        this.setCtx<TopBarContext>("TopBarContext", topBarContext, this.entryStep)

        if (!context) {
            console.log("[Transition] No choice data available, using default exits");
            return this.exitSteps;
        }

        if (!(context.routeTo ?? []).every(step => this.exitSteps.includes(step))) {
            console.log(`[Transition] Invalid choice: ${this.getCtx("choice")}`);
            return [];
        }

        return [...(context?.routeTo ?? [])]
    }

}